module.exports = __webpack_public_path__ + "app.png?f4772ca6bbc9cd815b7a18acba892bbe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.png
// module id = 661
// module chunks = 0